import React, { useEffect } from 'react';
import { getSalesAgentInfo } from 'merchant-api/spiceroad';
import { FormattedMessage } from 'react-intl';
import { formatPhone } from '@odmonorepo/odfunctions';
import { DefaultErrorPage } from '@odmonorepo/core-components';
import { useApplication } from 'merchant-api/unified';
import { useAnalytics } from 'use-analytics';
import { trackCheckoutBlockingError } from 'merchant-components';
import { AppError } from 'merchant-api';

export const IdentityFailed = () => {
  const salesAgentInfoProps = getSalesAgentInfo();
  const { salesAgentInfo, isSalesAgentInfoLoading } = salesAgentInfoProps;
  const useApplicationProps = useApplication();
  const analytics = useAnalytics();

  useEffect(() => {
    trackCheckoutBlockingError(analytics, AppError.IdologyVerificationFailed, salesAgentInfoProps, useApplicationProps);
  }, [salesAgentInfoProps.salesAgentInfo, useApplicationProps.opportunityId]);

  if (isSalesAgentInfoLoading) return null;

  const contactName = salesAgentInfo?.name ? salesAgentInfo.name : undefined;
  const phoneLink = salesAgentInfo?.phone ? 'tel:+1' + salesAgentInfo.phone : undefined;
  const callButton = salesAgentInfo?.phone ? 'Call ' + formatPhone(salesAgentInfo.phone) : undefined;

  return <DefaultErrorPage
    title={<FormattedMessage id="customError.identityFailed.title" />}
    message={salesAgentInfo?.name ? <FormattedMessage id="customError.identityFailed.salesAgentMessage" />
        : <FormattedMessage id="customError.identityFailed.genericMessage" />}
    contactName={contactName}
    contactDescription={salesAgentInfo?.name ? 'Loan Advisor' : undefined}
    link={phoneLink}
    CTA={callButton}
    cardTitle={<FormattedMessage id="customError.identityFailed.cardTitle" />}
  />
}

export default IdentityFailed;
